export const RECEIVE_INTEGRATIONS = 'RECEIVE_INTEGRATIONS';
export const RECEIVE_INTEGRATION = 'RECEIVE_INTEGRATION';
export const ERROR = 'ERROR';
